export default __webpack_public_path__ + "static/media/Leggings of the Still Pond.efdaf132.jpg";